// src/components/AdminSummaryStatistics.js (or your preferred path)

import React from "react";
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid2"; // Assuming you use Grid2 as in your example
import Person from "@mui/icons-material/Person";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import FlagCircleIcon from "@mui/icons-material/FlagCircle";
import TheaterComedyIcon from "@mui/icons-material/TheaterComedy";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import LocationCityIcon from "@mui/icons-material/LocationCity";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import ComplexStatisticsCard from "components/Cards/StatisticsCards/ComplexStatisticsCard";

const AdminSummaryStatistics = ({ adminDashboardData }) => {
  const statsList = [
    {
      id: "users",
      color: "success",
      icon: <Person />,
      title: "Users",
      count: adminDashboardData.users ?? 0,
      actionPath: "/admin/users/new-user",
    },
    {
      id: "partners",
      color: "info", // Changed color for variety, adjust as needed
      icon: <GroupWorkIcon />,
      title: "Partners",
      count: adminDashboardData.partners ?? 0,
      actionPath: "/admin/partners/new-partner",
    },
    {
      id: "destinations",
      color: "success",
      icon: <FlagCircleIcon />,
      title: "Destinations",
      count: adminDashboardData.destinations ?? 0,
      actionPath: "/admin/destinations/new-destination",
    },
    {
      id: "recommendations",
      color: "dark",
      icon: <TheaterComedyIcon />,
      title: "Recommendations",
      count: adminDashboardData.recommendations ?? 0,
      actionPath: "/admin/recommendations/new-recommendation", // Assuming role is admin for action path
    },
    {
      id: "tickets",
      color: "success",
      icon: <LocalActivityIcon />,
      title: "Tickets",
      count: adminDashboardData.tickets ?? 0,
      actionPath: "/admin/tickets/new-old-ticket", // Assuming role is admin
    },
    {
      id: "locations",
      color: "primary",
      icon: <LocationCityIcon />,
      title: "Locations",
      count: adminDashboardData.locations ?? 0,
      actionPath: "/admin/locations/new-location",
    },
  ];

  return (
    <MDBox mt={1.5}>
      {" "}
      <Grid container spacing={3}>
        {statsList.map((stat) => (
          <Grid size={{ xs: 12, md: 6, lg: 4 }} key={stat.id}>
            <MDBox mb={1.5}>
              {" "}
              <ComplexStatisticsCard
                color={stat.color}
                icon={stat.icon}
                title={stat.title}
                count={stat.count}
                subHeader={{
                  color: "success",
                  label: "Add new",
                  action: stat.actionPath,
                  amount: "",
                }}
              />
            </MDBox>
          </Grid>
        ))}
      </Grid>
    </MDBox>
  );
};

AdminSummaryStatistics.propTypes = {
  adminDashboardData: PropTypes.instanceOf(Object).isRequired, // Ensure this is an object
};

export default React.memo(AdminSummaryStatistics); // Memoize for performance
